module.exports = __webpack_public_path__ + "static/media/testfile_ssstuffsegmentation.e79aa4db.zip";